
import { Component } from '@angular/core';

@Component({
  selector: 'shared-footer',
  imports: [],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent {
fecha: Date = new Date();
currentYear=this.fecha.getFullYear();


}
